import {useTranslation} from "react-i18next";
import {useParams} from "react-router-dom";
import HeaderComponent from "./HeaderComponent";
import React from "react";

export default  function TermAndConditions() {
    const { type } = useParams();
    const { t } = useTranslation();
    const itemsP = () => {
        let items = [];
        for (let i=1; i <=4; i++) {
            items.push(<p key={i}>{t('TERM_AND_CONDITIONS.DESCRIPTION.' + type + '.P_' + i)}</p>)
        }

        return items
    }
    return (
        <div>
            <HeaderComponent loginPage={false}></HeaderComponent>
            <div className="container-terms" style={{maxWidth: '90%', margin: '6rem auto 20px'}}>
                <h1>{t('TERM_AND_CONDITIONS.TITLES.' + type)}</h1>

                {itemsP()}

                <p><strong>{t('TERM_AND_CONDITIONS.DESCRIPTION.BOLD')}</strong></p>
            </div>
        </div>);
}
